<template>
  <div
    class="max-w-[320px] max-h-10 mx-auto border-b border-[var(--color-9)] text-[var(--color-9)] flex items-start gap-4 justify-center overflow-hidden mt-8"
  >
    <video autoplay loop muted playsinline width="34" height="34">
      <source src="/images/blue-tick.webm" type="video/webm" />
    </video>
    <div class="flex flex-col gap-2 animate-[vertical-move_4s_infinite]">
      <p v-for="item in training" class="mt-1 text-center">{{ item }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  content: {
    type: String,
    default: "",
  },
});
const training = ref([
  "Laravel Certified Developers",
  "Availability in Your Timezone",
  "Experience in API Development",
  "Laravel Ecosystem Experties",
  "3rd API Integration",
]);

switch (props.content) {
  case "vue":
    training.value = [
      "Vue.js Certified Developers",
      "Availability in Your Timezone",
      "Experience in API Development",
      "Vue.js Ecosystem Experties",
      "3rd API Integration",
    ];
    break;
  case "flutter":
    training.value = [
      "Flutter Certified Developers",
      "Availability in Your Timezone",
      "Experience in API Development",
      "Flutter Ecosystem Experties",
      "3rd API Integration",
    ];
    break;
  case "nuxt":
    training.value = [
      "Nuxt.js Certified Developers",
      "Availability in Your Timezone",
      "Experience in API Development",
      "Nuxt.js Ecosystem Experties",
      "3rd API Integration",
    ];
    break;
  default:
    break;
}
</script>
